import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function FailedReloadAlert() {
  const [failedCount, setFailedCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFailedReloads = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/recurring-subscriptions/failed-reloads`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFailedCount(res.data.total_count);
      } catch (error) {
        console.error('Error fetching failed reloads', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFailedReloads();
    
    // Aktualisiere alle 5 Minuten
    const interval = setInterval(fetchFailedReloads, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading || failedCount === 0) {
    return null;
  }

  return (
    <Alert className="mb-4 bg-red-50 border-red-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-2xl">⚠️</span>
          <div>
            <AlertDescription className="font-semibold text-red-900">
              {failedCount} Abo{failedCount > 1 ? 's' : ''} mit Zahlungsproblemen
            </AlertDescription>
            <p className="text-sm text-red-700">
              Auto-Reload fehlgeschlagen - Kunden wurden benachrichtigt
            </p>
          </div>
        </div>
        <Button
          onClick={() => navigate('/failed-reloads')}
          variant="outline"
          className="border-red-300 text-red-900 hover:bg-red-100"
        >
          Details anzeigen
        </Button>
      </div>
    </Alert>
  );
}

export default FailedReloadAlert;
